import { Map } from "immutable";

export const IS_FINISHED = 'isFinished';

const initialState = Map({
  [IS_FINISHED]: false
});

export default initialState;